import React, { useContext, useEffect } from 'react'
import {Controller,useForm} from 'react-hook-form'
import { Box, Button, Card, CardContent, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@mui/material'
import dayjs from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StepperDataContext } from './AddEditCustomer';
import { useParams } from 'react-router-dom';
import { CustomerService } from '../Service';
import Swal from 'sweetalert2';
const ProfileDetails = () => {
  const {profileData,setProfileData,customerData,tabValue,setTabValue,fetchCustomerDetailById} = useContext(StepperDataContext)
  const {id} = useParams();
  const {control,handleSubmit,formState:{isDirty},reset} = useForm({
    mode:'onChange',
    defaultValues:profileData
  });
  const onSubmit = async(data) => {
    console.log(data);
    const modifiedData = {
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      gender: data.gender,
      email: data.email,
      dob: data.dob ? data.dob : null,
    }
    if(customerData?.profile){
      //update
      // progress dialog
      Swal.fire({
        title: 'Please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })
     const updateResponse = await CustomerService.updateCustomerDetails(modifiedData,customerData?.id );
     if (updateResponse.success == '1') {
        Swal.fire('Update Successfully', '', 'success');
        fetchCustomerDetailById(customerData?.id)
     }
    }else{
      //create
      let requiredData = {
        customerId:customerData?.id,//required
        mobileNumber:customerData?.mobileNumber,//required
        firstName:data?.firstName,//required
        middleName:data?.middleName,
        lastName:data?.lastName,//required
        email:data?.email || null,
        dob:data?.dob || null,
        gender:data?.gender || null,//ENUM('Male', 'Female', 'Prefer Not To Say')
        profileImage:null,
      }
      // progress dialog
      Swal.fire({
        title: 'Please wait...',
        text: 'Please wait while creating customer profile',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })
      const createProfile = await CustomerService.createCustomerProfile(requiredData);
      if (createProfile.success == '1') {
        Swal.fire({
          icon: 'success',
          title: 'Customer Profile Created Successfully',
          showConfirmButton: false,
          timer: 1000
        })
        fetchCustomerDetailById(customerData?.id)
      }else if(createProfile.success == '0'){
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: createProfile.message
        });
      }
    }
  }
  const handleCancel = async () =>{
    reset();
  }
  useEffect(()=>{
    if(customerData?.profile){
      reset(customerData?.profile);
    }
  },[customerData])
  return (
    <Card component={'form'} onSubmit={handleSubmit(onSubmit)} sx={{ overflow: "auto", backgroundColor: "#fff" }}>
      <CardContent>
        <Grid container spacing={2} sx={{ paddingTop: '15px' }}>
          <Grid item lg={9} xs={12} sx={{margin:'auto'}}>
            <Grid container spacing={2} sx={{ paddingTop: '15px' }}>
              <Grid item lg={4} xs={12}>
                <Typography sx={{fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>First Name<span style={{color:'#d32f2f'}}>*</span></Typography>
                <Controller
                  name="firstName"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "required",
                    pattern:{
                        value:/^[a-zA-Z]*$/,
                        message:"only alphabets allowed"
                    },
                    minLength:{
                        value:3,
                        message:"minimum 3 digit"
                    },
                    maxLength:{
                        value:30,
                        message:"maximum 30 digit"
                    }
                  }}
                  render={({ field,fieldState:{error }}) => (
                    <TextField
                      {...field}
                      inputProps={{
                        style:{
                          fontSize:'0.75rem'
                        }
                      }}
                      placeholder="Enter First Name"
                      // label="Enter First Name"
                      size="small"
                      fullWidth
                      error={!!error}
                      // helperText={errors.lastName && errors.lastName.message}
                    />
                  )}
                />
              </Grid>
              <Grid item lg={4} xs={12}>
                <Typography sx={{fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>Middle Name</Typography>
                <Controller
                  name="middleName"
                  control={control}
                  defaultValue=""
                  rules={{
                    // required: "required",
                    pattern:{
                        value:/^[a-zA-Z]*$/,
                        message:"only alphabets allowed"
                    },
                    minLength:{
                        value:3,
                        message:"minimum 3 digit"
                    },
                    maxLength:{
                        value:30,
                        message:"maximum 30 digit"
                    }
                  }}
                  render={({ field,fieldState:{error} }) => (
                    <TextField
                      {...field}
                      inputProps={{
                        style:{
                          fontSize:'0.75rem'
                        }
                      }}
                      placeholder="Enter Middle Name"
                      size="small"
                      fullWidth
                      error={!!error}
                    />
                  )}
                />
              </Grid>
              <Grid item lg={4} xs={12}>
                <Typography sx={{fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>Last Name<span style={{color:'#d32f2f'}}>*</span></Typography>
                <Controller
                  name="lastName"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "required",
                    pattern:{
                        value:/^[a-zA-Z]*$/,
                        message:"only alphabets allowed"
                    },
                    minLength:{
                        value:3,
                        message:"minimum 3 digit"
                    },
                    maxLength:{
                        value:30,
                        message:"maximum 30 digit"
                    }
                  }}
                  render={({ field,fieldState:{error} }) => (
                    <TextField
                      {...field}
                      inputProps={{
                        style:{
                          fontSize:'0.75rem'
                        }
                      }}
                      placeholder="Enter Last Name"
                      size="small"
                      fullWidth
                      error={!!error}
                    />
                  )}
                />
              </Grid>
              <Grid item lg={8} xs={12}>
                <Typography sx={{fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>Email</Typography>
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  rules={{
                    // required:'enter Email',
                    validate: (value) => {
                      // allow empty but if value then validate pattern
                    //   pattern:{
                    //     value:/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                    //     message:"Email is not Valid"
                    // }
                      if (!value) return true;
                      if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value)) {
                        return "Invalid email";
                      }
                      return true;
                    }
                  }}
                  render={({ field,fieldState:{error} }) => (
                    <TextField
                      {...field}
                      inputProps={{
                        style:{
                          fontSize:'0.75rem'
                        }
                      }}
                      placeholder="Enter Email"
                      // label="Enter Email"
                      size="small"
                      fullWidth
                      onChange={(e) => {
                        const value = e.target.value.toLowerCase();
                        field.onChange(value);
                      }}
                      error={!!error}
                    />
                  )}
                />
              </Grid>

            {/* <Grid item lg={4} xs={12}>
              <Typography sx={{fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>Mobile Number<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                  name="mobileNumber"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: 'Mobile number is required',
                      pattern: {
                        value: /^[1-9][0-9]{9}$/,
                        message: "Enter a valid 10-digit number not starting with 0"
                    },
                    validate: (value) => {
                      if (value && value.length !== 10) {
                        return "Mobile number must be exactly 10 digits";
                      }
                      return true;
                    }
                  }}
                  render={({ field,fieldState:{error} }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Mobile Number"
                      // label="Enter Mobile Number"
                      size="small"
                      type='number'
                      fullWidth
                      disabled ={id>0}
                      error={!!errors.mobileNumber}
                      inputProps={{
                        maxLength: 10,
                        style:{
                          fontSize:'0.75rem'
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                        field.onChange(value);
                      }}
                    />
                  )}
                />
              </Grid> */}
              <Grid item lg={4} xs={12}>
                <Typography sx={{width:'60%' ,fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>Gender<span style={{color:'#d32f2f'}}>*</span></Typography>
                <Controller
                  name='gender'
                  control={control}
                  rules={{required:'select gender'}}
                  render={({field,fieldState:{error}})=>(
                      <FormControl size='small' sx={{ minWidth: "100%" }}>
                        {/* <InputLabel id="">Select Gender</InputLabel> */}
                          <Select
                              {...field}
                              size='small'
                              placeholder='Select Gender'
                              error={!!error}
                              sx={{
                                minHeight: '0px',
                                // height: '1.6rem',
                                fontSize: '0.75rem',
                                // fontWeight: '600',
                                textTransform:'capitalize'
                              }}
                          >
                            <MenuItem value="Male" sx={{fontSize:'0.75rem'}}>Male</MenuItem>
                            <MenuItem value="Female" sx={{fontSize:'0.75rem'}}>Female</MenuItem>
                            <MenuItem value="Prefer Not To Say" sx={{fontSize:'0.75rem'}}>Other</MenuItem>
                          </Select>
                      </FormControl>
                  )}  
                />
              </Grid>
              <Grid item lg={4} xs={12}>
                <Typography sx={{fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>Date Of Birth</Typography>
                <Controller
                  name="dob"
                  control={control}
                  rules={{
                    // required: "Date of Birth is required",
                    validate: (value) => {
                      if (!value) return true;
                      const date = dayjs(value);
                      const today = dayjs().startOf('day');
                      const eighteenYearsAgo = today.subtract(18, 'year');
                      
                      if (!date.isValid()) return "Invalid date";
                      if (date.isAfter(today)) return "Date of Birth must be in the past";
                      if (date.isAfter(eighteenYearsAgo)) return "must be at least 18 years old";
                      
                      return true;
                    }
                  }}
                  render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        {...restField}
                        value={value ? dayjs(value) : null}
                        onChange={(newValue) => {
                          // Store the date in YYYY-MM-DD format for database compatibility
                          onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                        }}
                        format="DD-MM-YYYY" // Display format for user
                        maxDate={dayjs()}
                        slotProps={{
                          textField: {
                            error: !!error,
                            helperText: error?.message,
                            fullWidth: true,
                            // required: true,
                            size: 'small',
                            inputProps: {
                              style: { fontSize: '.75rem' }
                            }
                          }
                        }}
                      />
                    </LocalizationProvider>
                  )}
                />
              </Grid>
              {/* <Grid item lg={12} xs={12}>
                <Box textAlign={'center'}>
                  <Button disabled={isLoading||isSubmitting||!isDirty} type="submit" variant="contained" color="primary" size='small'>
                    {id>0 ? 'update':'Register'}
                  </Button>
                  <Box sx={{ flexGrow: 1 }}></Box>
                </Box>
              </Grid> */}
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{display:'flex',justifyContent:'center',alignItems:'center',gap:1}}>
            {/* cancel Button */}
            <Button size='small' variant='contained' color='error' sx={{textTransform:'capitalize'}} onClick={handleCancel}
              disabled={!isDirty}
            >
              Cancel
            </Button>
            <Button size='small' variant='contained' sx={{textTransform:'capitalize'}} type="submit"
              disabled={!isDirty}
            >
              {customerData?.profile ? 'update':'Create Profile'}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  )
}

export default ProfileDetails
